import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { init as t } from "../../core/watchUtils.js";
import { aliasOf as s } from "../../core/accessorSupport/decorators/aliasOf.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { property as r } from "../../core/accessorSupport/decorators/property.js";
import { subclass as i } from "../../core/accessorSupport/decorators/subclass.js";
import o from "../Widget.js";
import l from "./FeatureFields/FeatureFieldsViewModel.js";
import a from "./support/FeatureElementInfo.js";
import { autoLink as d } from "../support/uriUtils.js";
import "../support/widgetUtils.js";
import { messageBundle as n } from "../support/decorators/messageBundle.js";
import "../../core/Logger.js";
import { tsx as p } from "../support/jsxFactory.js";
var f = {
  base: "esri-feature-fields",
  fieldHeader: "esri-feature-fields__field-header",
  fieldData: "esri-feature-fields__field-data",
  fieldDataDate: "esri-feature-fields__field-data--date",
  esriTable: "esri-widget__table"
};

var u = /*#__PURE__*/function (_o) {
  _inherits(u, _o);

  var _super = _createSuper(u);

  function u(e, t) {
    var _this;

    _classCallCheck(this, u);

    _this = _super.call(this, e, t), _this._featureElementInfo = null, _this.attributes = null, _this.description = null, _this.expressionInfos = null, _this.fieldInfos = null, _this.title = null, _this.viewModel = new l(), _this.messages = null, _this.messagesURIUtils = null;
    return _this;
  }

  _createClass(u, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this._featureElementInfo = new a(), t(this, ["viewModel.description", "viewModel.title"], function () {
        return _this2._setupFeatureElementInfo();
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._featureElementInfo.destroy();
    }
  }, {
    key: "renderFieldInfo",
    value: function renderFieldInfo(e, t) {
      var s = this.viewModel.attributes,
          r = e.fieldName,
          i = e.label || r,
          o = s ? null == s[r] ? "" : s[r] : "",
          l = !(!e.format || !e.format.dateFormat),
          a = "number" == typeof o && !l ? this._forceLTR(o) : d(this.messagesURIUtils, o),
          n = _defineProperty({}, f.fieldDataDate, l);

      return p("tr", {
        key: "fields-element-info-row-".concat(r, "-").concat(t)
      }, p("th", {
        key: "fields-element-info-row-header-".concat(r, "-").concat(t),
        class: f.fieldHeader,
        innerHTML: i
      }), p("td", {
        key: "fields-element-info-row-data-".concat(r, "-").concat(t),
        class: this.classes(f.fieldData, n),
        innerHTML: a
      }));
    }
  }, {
    key: "renderFields",
    value: function renderFields() {
      var _this3 = this;

      var e = this.viewModel.formattedFieldInfos;
      return null != e && e.length ? p("table", {
        class: f.esriTable,
        summary: this.messages.fieldsSummary
      }, p("tbody", null, e.map(function (e, t) {
        return _this3.renderFieldInfo(e, t);
      }))) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var e;
      return p("div", {
        class: f.base
      }, null == (e = this._featureElementInfo) ? void 0 : e.render(), this.renderFields());
    }
  }, {
    key: "_setupFeatureElementInfo",
    value: function _setupFeatureElementInfo() {
      var e = this.description,
          t = this.title;

      this._featureElementInfo.set({
        description: e,
        title: t
      });
    }
  }, {
    key: "_forceLTR",
    value: function _forceLTR(e) {
      return "&lrm;".concat(e);
    }
  }]);

  return u;
}(o);

e([s("viewModel.attributes")], u.prototype, "attributes", void 0), e([s("viewModel.description")], u.prototype, "description", void 0), e([s("viewModel.expressionInfos")], u.prototype, "expressionInfos", void 0), e([s("viewModel.fieldInfos")], u.prototype, "fieldInfos", void 0), e([s("viewModel.title")], u.prototype, "title", void 0), e([r({
  type: l
})], u.prototype, "viewModel", void 0), e([r(), n("esri/widgets/Feature/t9n/Feature")], u.prototype, "messages", void 0), e([r(), n("esri/widgets/support/t9n/uriUtils")], u.prototype, "messagesURIUtils", void 0), u = e([i("esri.widgets.Feature.FeatureFields")], u);
var m = u;
export { m as default };